var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.list
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5131fd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/List/List.vue
// module id = 588
// module chunks = 0